module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_chestnut.e0f9845c.png";